/*
 * Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { BciLayoutIntl } from "../layout-intl";
import { BreadcrumbsService } from "../../breadcrumbs.service";

@Component({
    selector: "bci-header",
    templateUrl: "./bci-header.component.html",
    styleUrls: ["./bci-header.component.scss"],
    standalone: false
})
export class BciHeaderComponent implements OnInit {
  @Input() public header = "";
  @Input() public logoRoute = "/";

  constructor(
    public layoutIntl: BciLayoutIntl,
    private router: Router,
    public breadcrumbService: BreadcrumbsService
  ) {}

  ngOnInit() {}

  onLogoClicked() {
    /*TODO: Cursor:pointer when logoLink or logoRoute is set*/
    if (this.logoRoute) {
      this.router.navigate([this.logoRoute]);
    }
  }
}
